/* eslint-disable no-unused-vars */
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import CryptoJS from "crypto-js"
import { useDispatch } from "react-redux";
import { loginUser } from "../../actions/user";
import api from '../../services/api'
import signinImg from "../../images/signinImg.svg";
import { useAuth } from "../../hooks/auth";
import { enqueueSnackbar } from "notistack";
import { Box, Button, Checkbox, FormControlLabel, Link, TextField, Typography } from "@mui/material";

const Login = () => {

  const { isAuthenticated, setUser } = useAuth();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [isLoad, setIsLoad] = useState(false)
  const [login, setLogin] = useState(false)
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')

  async function doLogin(e) {
    e.preventDefault();
    //this.changeLoad(true)
    setIsLoad(true)
    try {
      const response = await api.post('/subscription/loginByPasswordAdmin', {
        email: email,
        password: password
      });
      if (response.data.token.token) {
        var encryptToken = CryptoJS.AES.encrypt(response.data.token.token, process.env.REACT_APP_TOKEN_ENCRYPT_HASH).toString();
        dispatch(
          loginUser(encryptToken)
        );
        var array =
        {
          name: response.data.username,
          email: response.data.email,
          username: response.data.username,
          personne_id: response.data.personne_id,
          routes: response.data.routes ? response.data.routes : []
        }

        localStorage.setItem('user', JSON.stringify(array));
        await setUser(array)
      
        enqueueSnackbar('Login realizado com sucesso!', { variant: 'success' });
        setLogin(true)
        return navigate('/')
      } else {
        enqueueSnackbar('E-mail e/ou senha incorreto(s)', { variant: 'error' });
      }
      
    } catch (error) {
      enqueueSnackbar('E-mail e/ou senha incorreto(s)!', { variant: 'error' });
    } finally {
      setIsLoad(false)
    }
  }

  const handleEmail = (e) => {
    setEmail(e.target.value)
  }
  const handlePassword = (e) => {
    setPassword(e.target.value)
  }

  useEffect(() => {
    if (isAuthenticated()) {
      return navigate('/')
    }

    if (login) {
      return navigate('/')
    }
  }, [login])

  return (
    <Box
      sx={{
        height: '100vh',
        backgroundColor: '#fff',
        paddingY: 0,
        paddingX: {sx: '0', sm: '40px'},
      }}
    >
      <Box
        sx={{
          display: 'flex',
          background: 'none',
          maxWidth: {xs: '100%', sm: '360px'},
          padding: '10px',
          height: '100vh',
          flexDirection: 'column',
          justifyContent: 'center',
        }}
      >
        <Typography variant="h3" sx={{fontSize: '40px'}}>
          Login
        </Typography>
        <Typography
          variant="p"
          sx={{
            fontSize: '18px',
            color: '#464646',
            marginBottom: '20px',
            marginTop: '10px',
          }}
        >
          Bem vindo! Por favor faça o login
        </Typography>
        
        <Box component='form' onSubmit={doLogin}>
          <Box sx={{
            display: 'flex',
            flexDirection: 'column',
            marginY: 3,
            gap: 3
          }}>
            <TextField
              sx={{
                border: '1px',
                borderColor: '#323232',
                placeHolderColor: '#464646',
                borderRadius: 2,
              }}
              fullWidth
              id={`email`}
              label="E-mail"
              value={email}
              onChange={(event) => {
                handleEmail(event);
              }}
            />
          
            <TextField
              sx={{
                border: '1px',
                borderColor: '#323232',
                placeHolderColor: '#464646',
                borderRadius: 2,
              }}
              fullWidth
              required
              id={`password`}
              label="Senha"
              type="password"
              value={password}
              onChange={(event) => {
                handlePassword(event);
              }}
            />
          </Box>

          <Box sx={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginLeft: '-11px', 
          }}>
            <FormControlLabel sx={{margin: 0}} control={<Checkbox />} label="Lembrar-me" />
            <Link color='error'    href="/" underline="none">
              {'Esqueceu sua senha?'}
            </Link>
          </Box>

          <Button
            type="submit"
            color="warning"
            variant='contained'
            sx={{
              marginTop: 2,
              borderRadius: 2,
            }}
            fullWidth
          >
            {isLoad ? "Carregando..." : "Login"}
          </Button>
          <Typography
            variant="h3"
            sx={{
              fontSize: '14px',
              position: 'absolute',
              bottom: '20px',
              color: '#29323a'
            }}>
            {new Date().getFullYear()} © FinPEC - Admin Dashboard
          </Typography>
        </Box>
      </Box>
      <Box
        component="img"
        sx={{
          position: 'absolute',
          right: 0,
          bottom: 0,
          maxHeight: '85%',
          display: {xs: 'none', sm: 'flex'},
        }}
        alt="signin"
        src={signinImg}
      />
    </Box>
  );
}

export default Login;
